export const lookingForContent = [
  {
    id: 1,
    faIcon: "fa-solid fa-house-circle-check",
    heading: "Looking for help to manage your property?",
    text: "Work with us for a stress free experience to maximize your rental income.",
  },
  {
    id: 2,
    faIcon: "fa-solid fa-house-chimney-user",
    heading: "Looking for a stay for your family or staff?",
    text: "All our properties are well maintained, clean, bright, spacious, fully furnished and equipped with 24/7 support. It’s your home away from home.",
  },
];
